const SmallLoader = ({ className }) => {
    return (
        <span className={"loading-xs"}>
            <i className={`sprite sprite-${className}`} />
        </span>
    );
};

export default SmallLoader;
